import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IHRLocation } from '@api/types'

interface IEmployeeWithLocations {
  id: string
  preferredLocations: IHRLocation[]
}

function _fetch(employeeId?: string): Promise<IEmployeeWithLocations> {
  return employeeId ? fetchID(employeeId) : fetchNoID()
}
function fetchID(id: string): Promise<IEmployeeWithLocations> {
  return client.gql
    .query({
      query: queryID,
      variables: { input: { id } },
    })
    .then(({ data: { node } }: any) => node)
}
function fetchNoID(): Promise<IEmployeeWithLocations> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: { employee },
      },
    }: any) => employee
  )
}

function update(employeeId: string, locationIds: string[]): Promise<IEmployeeWithLocations> {
  return client.gql
    .mutate({
      mutation,
      variables: { input: { id: employeeId, locationIds } },
    })
    .then(
      ({
        data: {
          setPreferredLocationsForEmployee: { employee },
        },
      }: any) => employee
    )
}

const mutation = gql`
  mutation _($input: SetPreferredLocationsForEmployeeInput!) {
    setPreferredLocationsForEmployee(input: $input) {
      employee {
        id
        preferredLocations {
          id
          location
        }
      }
    }
  }
`
const queryID = gql`
  query Employees($id: ID!) {
    node(id: $id) {
      ... on Employee {
        preferredLocations {
          id
          location
        }
      }
    }
  }
`
const query = gql`
  {
    viewer {
      employee {
        preferredLocations {
          id
          location
        }
      }
    }
  }
`

export default { fetch: _fetch, update }
